import config from '../config.json';

// Reads config-values from config.json. If the fieldName queried is not found directly, 
//the function will try to find the fieldName under the current environment, e.g. QA or PROD
export function getConfigValue(fieldName) {

   
    const value = config[fieldName];    

    if (value)
        return value; 
    else {
        //const environment = config['environment'];
        const environment = getEnvironmentDynamically();

        return config[environment][fieldName];
    }




}

const getEnvironmentDynamically = () => {
    if (window.location.host.includes("localhost")) //react app is served from localhost, use dev config
        return 'dev';
    else 
        return config['deployEnvironment']; //qa, prod


}

